import React from 'react';
import { withRouter } from 'react-router-dom';
import {logout} from '../../services/Auth'
import './style.css'
//import '../Button/button.css'

class Logoutbutton extends React.Component{
    handleSubmit = () => {
        logout();
        localStorage.clear();
        this.props.history.push("/");
    }
    render(){
        return(
            <>
                <button onClick={() => this.handleSubmit()} id='btnloggout'>Fazer Logout</button>
            </>
        );
    }
}
Logoutbutton = withRouter(Logoutbutton);
export default Logoutbutton;
